import { render, staticRenderFns } from "./TimeDuration.vue?vue&type=template&id=72149a8d&functional=true"
import script from "./TimeDuration.vue?vue&type=script&lang=js"
export * from "./TimeDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports